import CancellableHelper from "@/requests/CancellableHelper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { GDS, GDSFormOfPayment, GDSServiceResponse, GDSSettings } from "@/models/api/administration/gds/gds";

export const URL_GET_GDS_LIST = "/GDS";
export const URL_GET_ACTIVE_GDS_LIST = "/GDS/Active";
export const URL_GET_ADMINISTRATION_GDS_LIST = "/GDS/Administration";
export const URL_POST_TOGGLE_GDS = "/GDS/Toggle/${GDSId}";

export const URL_GET_GDS_SERVICES = "/GDS/Services";
export const URL_GET_GDS_SETTINGS = "/GDS/Settings/${ServiceTypeId}";
export const URL_GET_GDS_FORMS_OF_PAYMENT = "/GDS/FormsOfPayment/${ServiceTypeId}/${GDSId}";
export const URL_POST_TOGGLE_GDS_SETTINGS = "/GDS/ToggleGDSSettings/${ServiceTypeId}/${GDSId}";
export const URL_POST_TOGGLE_IS_COST_DOCUMENT_REQUIRED =
  "/GDS/ToggleGDSIsCostDocumentRequired/${ServiceTypeId}/${GDSId}";
export const URL_POST_TOGGLE_FORM_OF_PAYMENT =
  "/GDS/ToggleGDSFormOfPayment/${ServiceTypeId}/${GDSId}/${FormOfPaymentId}";

//Common
const _getGDSList = new CancellableHelper<Array<GDS>>(URL_GET_GDS_LIST, GDS);
export const getGDSList = async (): Promise<Array<GDS>> => {
  return await _getGDSList.get();
};

const _getActiveGDSList = new CancellableHelper<Array<GDS>>(URL_GET_ACTIVE_GDS_LIST, GDS);
export const getActiveGDSList = async (): Promise<Array<GDS>> => {
  return await _getActiveGDSList.get();
};

//GDS
const _getAdministrationGDSList = new CancellableHelper<Array<GDS>>(URL_GET_ADMINISTRATION_GDS_LIST, GDS);
export const getAdministrationGDSList = async (): Promise<Array<GDS>> => {
  return await _getAdministrationGDSList.get();
};

const _toggleGDS = new CancellableHelper<null>(URL_POST_TOGGLE_GDS);
export const toggleGDS = async (id: number): Promise<null> => {
  return await _toggleGDS.post({ GDSId: id });
};

//GDS Settings
const _getGDSServices = new CancellableHelper<GDSServiceResponse>(URL_GET_GDS_SERVICES, GDSServiceResponse);
_getGDSServices.jsonSerializer = true;
export const getGDSServices = async (genericTableRequest: GenericTableRequest): Promise<GDSServiceResponse> => {
  return await _getGDSServices.get(genericTableRequest);
};

const _getGDSSettings = new CancellableHelper<Array<GDSSettings>>(URL_GET_GDS_SETTINGS, GDSSettings);
export const getGDSSettings = async (serviceTypeId: number): Promise<Array<GDSSettings>> => {
  return await _getGDSSettings.get({ ServiceTypeId: serviceTypeId });
};

const _getGDSFormsOfPayment = new CancellableHelper<Array<GDSFormOfPayment>>(
  URL_GET_GDS_FORMS_OF_PAYMENT,
  GDSFormOfPayment
);
export const getGDSFormsOfPayment = async (serviceTypeId: number, gdsId: number): Promise<Array<GDSFormOfPayment>> => {
  return await _getGDSFormsOfPayment.get({ ServiceTypeId: serviceTypeId, GDSId: gdsId });
};

const _toggleGDSSettings = new CancellableHelper<null>(URL_POST_TOGGLE_GDS_SETTINGS);
export const toggleGDSSettings = async (serviceTypeId: number, gdsId: number): Promise<null> => {
  return await _toggleGDSSettings.post({ ServiceTypeId: serviceTypeId, GDSId: gdsId });
};

const _toggleGDSIsCostDocumentRequired = new CancellableHelper<null>(URL_POST_TOGGLE_IS_COST_DOCUMENT_REQUIRED);
export const toggleGDSIsCostDocumentRequired = async (serviceTypeId: number, gdsId: number): Promise<null> => {
  return await _toggleGDSIsCostDocumentRequired.post({ ServiceTypeId: serviceTypeId, GDSId: gdsId });
};

const _toggleGDSFormOfPayment = new CancellableHelper<null>(URL_POST_TOGGLE_FORM_OF_PAYMENT);
export const toggleGDSFormOfPayment = async (
  serviceTypeId: number,
  gdsId: number,
  formOfPaymentId: number
): Promise<null> => {
  return await _toggleGDSFormOfPayment.post({
    ServiceTypeId: serviceTypeId,
    GDSId: gdsId,
    FormOfPaymentId: formOfPaymentId,
  });
};
